<template>
  <div>
    <v-list>
      <v-list-item-group v-model="mapTool">
        <v-list-item
          v-for="tool in allowedTools"
          :key="tool.key"
          :disabled="tool.disabled"
        >
          <v-list-item-icon class="mr-5">
            <v-icon v-text="tool.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="tool.name"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <div class="pt-7">
      <component
        v-if="typeof mapTool !== 'undefined' && mapTool !== null"
        :is="toolSettings"
        @change="handleChange"
      />
    </div>
  </div>
</template>

<script>
import ToolSettingsRoute from "./tools/ToolSettingsRoute";
import ToolSettingsPerimeter from "./tools/ToolSettingsPerimeter";
import ToolSettingsPolygon from "./tools/ToolSettingsPolygon";
import ToolSettingsHeatmap from "./tools/ToolSettingsHeatmap";

export default {
  name: "MapTools",
  components: {
    ToolSettingsRoute,
    ToolSettingsPerimeter,
    ToolSettingsPolygon,
    ToolSettingsHeatmap
  },
  data() {
    return {
      mapTool: null,
      mapTools: [
        {
          key: "route",
          name: "Routen-Suche",
          icon: "mdi-highway",
          disabled: false,
          permission: "ROLE_DSN_READ_TOOL_ROUTE"
        },
        {
          key: "perimeter",
          name: "Umkreis-Suche",
          icon: "mdi-map-marker-radius",
          disabled: false,
          permission: "ROLE_DSN_READ_TOOL_PERIMETER"
        },
        {
          key: "polygon",
          name: "Polygon-Tool",
          icon: "mdi-vector-square",
          disabled: false,
          permission: "ROLE_DSN_READ_TOOL_POLYGON"
        },
        {
          key: "heatmap",
          name: "Heatmap",
          icon: "mdi-thermometer-lines",
          disabled: false,
          permission: "ROLE_DSN_READ_TOOL_HEATMAP"
        }
      ],
      toolActive: false
    };
  },
  computed: {
    toolSettings() {
      return "tool-settings-" + this.allowedTools[this.mapTool].key;
    },

    allowedTools() {
      return this.mapTools.filter(tool =>
        this.$authorizationService.can(tool.permission)
      );
    }
  },
  methods: {
    handleChange(toolActive) {
      this.toolActive = toolActive;
      this.emitChange();

      if (toolActive) {
        this.refreshMap();
      } else {
        this.emitEmptyFilter();
      }
    },
    refreshMap() {
      this.$emit("refreshMap", true);
    },
    emitChange() {
      this.$emit("change", this.toolActive);
    },
    emitEmptyFilter() {
      this.$emit("emptyFilter");
    }
  },
  watch: {
    mapTool() {
      const mapTool = this.allowedTools[this.mapTool]
        ? this.allowedTools[this.mapTool].key
        : null;

      this.$root.$emit("toolChanged", mapTool);
      this.handleChange(false);
    }
  }
};
</script>

<style scoped></style>
